var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortingToggleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 2C6.50625 2 6 2.50625 6 3.125C6 3.74375 6.50625 4.25 7.125 4.25C7.74375 4.25 8.25 3.74375 8.25 3.125C8.25 2.50625 7.74375 2 7.125 2ZM7.125 13.25C6.50625 13.25 6 13.7563 6 14.375C6 14.9937 6.50625 15.5 7.125 15.5C7.74375 15.5 8.25 14.9937 8.25 14.375C8.25 13.7563 7.74375 13.25 7.125 13.25ZM7.125 7.625C6.50625 7.625 6 8.13125 6 8.75C6 9.36875 6.50625 9.875 7.125 9.875C7.74375 9.875 8.25 9.36875 8.25 8.75C8.25 8.13125 7.74375 7.625 7.125 7.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2C10.6313 2 10.125 2.50625 10.125 3.125C10.125 3.74375 10.6313 4.25 11.25 4.25C11.8687 4.25 12.375 3.74375 12.375 3.125C12.375 2.50625 11.8687 2 11.25 2ZM11.25 13.25C10.6313 13.25 10.125 13.7563 10.125 14.375C10.125 14.9937 10.6313 15.5 11.25 15.5C11.8687 15.5 12.375 14.9937 12.375 14.375C12.375 13.7563 11.8687 13.25 11.25 13.25ZM11.25 7.625C10.6313 7.625 10.125 8.13125 10.125 8.75C10.125 9.36875 10.6313 9.875 11.25 9.875C11.8687 9.875 12.375 9.36875 12.375 8.75C12.375 8.13125 11.8687 7.625 11.25 7.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingToggleIcon);
export default __webpack_public_path__ + "static/media/SortingToggleIcon.47ede50ffac3ce2c993ecec62cad56d9.svg";
export { ForwardRef as ReactComponent };